import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { initObservability, Sentry } from './lib/observability'
// The shared JA Consultores / SAFT-AI design system — GLOBAL since the 2026-08-26 staff
// restyle (it used to live in the lazy PortalLayout chunk). ORDER IS LOAD-BEARING: the DS
// must come BEFORE globals.css so Tailwind utilities win specificity ties against the
// unscoped single-class `platform-*` rules (later stylesheet wins) — the staff sidebar
// relies on this to override `.platform-sidebar`'s position:fixed with a Tailwind `static`.
import '@ja-consultores/design-system/css'
import './styles/globals.css'

// Init Sentry + PostHog before mounting React so the error boundary
// reports anything that goes wrong inside <App />. Both are no-ops
// unless their respective env vars are set at build time.
initObservability()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Missing #root element in index.html')

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="p-8 text-sm text-gray-600">Algo correu mal. Recarregue a página.</div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
